module.exports = __webpack_public_path__ + "static/media/agency-logo.d771214a.png";